"use strict";

exports.__esModule = true;
exports.createStyles = exports.fixedStyles = void 0;

var _layout = _interopRequireDefault(require("../../../common/constants/layout"));

var _scrollDirection = _interopRequireDefault(require("../../../common/constants/scrollDirection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fixedStyles = {
  galleryLayout: _layout["default"].MASONRY,
  cubeImages: false,
  scrollDirection: _scrollDirection["default"].VERTICAL,
  groupSize: 1,
  groupTypes: '1',
  //this params were moved from the presets in layoutHelper and were not tested and checked yet.
  gallerySize: 0,
  fixedColumns: 0,
  enableScroll: true,
  isGrid: false,
  isSlider: false,
  isMasonry: true,
  isColumns: false,
  isSlideshow: false,
  cropOnlyFill: false,
  oneRow: false
};
exports.fixedStyles = fixedStyles;

var createStyles = function createStyles(styles) {
  return _objectSpread(_objectSpread(_objectSpread({}, styles), fixedStyles), {}, {
    gallerySize: styles.gallerySize
  });
};

exports.createStyles = createStyles;